export type SeoFaqItem = {
  question: string;
  answer: string;
};

export type SeoHowToStep = {
  name: string;
  text: string;
};

export const ROUTE_FAQS: Record<string, SeoFaqItem[]> = {
  "/marketplace/": [
    {
      question: "Marketplace 页面收录的是什么？",
      answer:
        "Marketplace 收录的是公开可发现的 Hotline 目录入口。它展示 responder、能力标签、任务类型、template 线索和基础状态，帮助 Caller 先判断是否值得继续接入。",
    },
    {
      question: "第一次逛 Marketplace 应该怎么看？",
      answer:
        "先按任务类型和能力标签缩小范围，再查看 hotline summary、输入输出能力和 responder 来源。确认方向后，继续回到 Quick Start 或 Docs 看接入与调用细节。",
    },
    {
      question: "为什么部分 Hotline 详情页不做索引？",
      answer:
        "因为很多 Hotline 详情是动态目录页，内容更新频繁且可能重复聚合。当前站点优先让首页、Marketplace、Docs 和 Quick Start 这些稳定入口被搜索引擎收录，把深层详情页保留给用户在站内继续发现。",
    },
  ],
  "/docs/": [
    {
      question: "文档中心包含哪些内容？",
      answer:
        "Docs 覆盖快速开始、协议规范、Client SDK、Platform API、自托管部署和 Hotline 开发。它既适合第一次接入，也适合已经开始做 Caller 或 Responder 的工程团队查字段和命令。",
    },
    {
      question: "第一次阅读应该先看哪一页？",
      answer:
        "如果你是能力调用方，先看 Quick Start for Callers；如果你是能力提供方，先看 Quick Start for Responders。两页都以 5 分钟可跑通的最小闭环为目标。",
    },
    {
      question: "Docs 和 Marketplace 的关系是什么？",
      answer:
        "Marketplace 负责发现公开能力目录，Docs 负责解释协议、命令、部署方式和接入流程。前者告诉你有哪些 Hotline，后者告诉你怎么调用或发布这些 Hotline。",
    },
  ],
  "/docs/quick-start-caller/": [
    {
      question: "Caller Quick Start 适合谁？",
      answer:
        "它适合希望把外部能力接进 Agent、但还不想先部署完整 Platform 的团队。页面使用 Local Mode 演示最小调用闭环，方便先验证协议体验。",
    },
    {
      question: "这页为什么先用 example hotline？",
      answer:
        "因为它能把 Caller、supervisor 和 Responder 三段链路先稳定跑通，先验证协议流程，再决定接入真实业务 Hotline，能显著减少排查范围。",
    },
    {
      question: "完成后下一步做什么？",
      answer:
        "通常有两条路：继续浏览 Marketplace 选择更多 Hotline，或者进入 Console 原型理解审批、路由和运行时状态。若你也想提供能力，则直接进入 Responder Quick Start。",
    },
  ],
  "/docs/quick-start-responder/": [
    {
      question: "Responder Quick Start 会教什么？",
      answer:
        "它会带你从安装 client、启用 responder 角色、跑通 example hotline，到新增自己的 hotline draft 并提交 Marketplace 审核，完成供给方最小闭环。",
    },
    {
      question: "没有 Platform 也能发布 Hotline 吗？",
      answer:
        "可以。没有 Platform 时，你仍然可以在本机或自托管环境中通过 supervisor 私有 catalog 暴露热线能力，只是不会进入公网 Marketplace。",
    },
    {
      question: "写 Hotline 时最关键的字段是什么？",
      answer:
        "最关键的是 summary、input_schema、output_schema、示例和风险说明。它们直接决定 Caller 是否理解你的能力、能否稳定调用，以及 Marketplace 审核是否容易通过。",
    },
  ],
  "/docs/protocol-architecture/": [
    {
      question: "协议架构页主要解释什么？",
      answer:
        "这页专门解释 Protocol、Client、Platform、Selfhost 四层各自负责什么，以及 control plane 和 data plane 为什么要分开。它解决的是“系统怎么运转”，不是“品牌为什么成立”。",
    },
    {
      question: "为什么要把这部分从首页拆出来？",
      answer:
        "因为首页主要负责产品定位、Marketplace 和 Hotline 商业模型。架构图适合工程师深读，但放在首页会把检索意图和答案引擎抽取意图混在一起，拆出去后边界更清晰。",
    },
    {
      question: "Platform 和 Selfhost 到底是什么关系？",
      answer:
        "它们是同一份控制面服务的两种部署方式。Platform 是官方托管形态，Selfhost 是你在自己基础设施里部署同样的控制面能力；协议和调用外形不变，运营边界不同。",
    },
  ],
  "/docs/deployability-profiles/": [
    {
      question: "这页和 Quick Start 有什么区别？",
      answer:
        "Quick Start 教你先跑通 Caller 或 Responder 的最小闭环；部署 Profiles 解释 Local Agent Loop、Selfhost Platform、Public Stack 和 Management Console 四条路径分别适合什么场景、哪些已经 ready now、哪些仍是 planned。",
    },
    {
      question: "为什么 public-stack 会在某些配置下失败？",
      answer:
        "因为公网暴露前必须先发现风险。public-stack preflight 会检查 placeholder secrets、unsafe public origin、compose config 和 edge route contract；这些失败是安全边界，不是体验瑕疵。",
    },
    {
      question: "Selfhost 是否等于另一套产品？",
      answer:
        "不是。Selfhost 是同一 Platform 控制面的私有部署 profile，协议和调用外形不变；变化的是数据、secrets、日志、console 和公网暴露边界由 operator 自己管理。",
    },
  ],
};

export const ROUTE_HOWTO_STEPS: Record<string, SeoHowToStep[]> = {
  "/docs/quick-start-caller/": [
    {
      name: "安装 client 并启动 supervisor",
      text: "拉取 delegated-execution-dev 仓库，安装依赖，并在 repos/client 中启动本地 supervisor。",
    },
    {
      name: "初始化并注册 Caller 身份",
      text: "调用 setup 和 auth/session/setup，拿到会话 token，然后注册一个本地 Caller 账号。",
    },
    {
      name: "挂上 example hotline",
      text: "启用 responder 角色，挂上内置 example hotline，让本机同时扮演 Responder 做联调。",
    },
    {
      name: "列 catalog 并发起调用",
      text: "通过 catalog API 确认 Hotline 已可见，然后发起一次 example request。",
    },
    {
      name: "读取 result_package",
      text: "查询请求结果，读取 status、hotline_id、output 和 timing 字段，确认协议返回形状。",
    },
  ],
  "/docs/quick-start-responder/": [
    {
      name: "安装 client 并启动 supervisor",
      text: "拉取 delegated-execution-dev 仓库，在 repos/client 安装依赖并启动本地 supervisor。",
    },
    {
      name: "注册并启用 Responder 身份",
      text: "注册本地或 Platform 账号，随后启用 responder 角色，准备好热线注册槽位。",
    },
    {
      name: "用 example hotline 验证链路",
      text: "先添加内置 example hotline，确认 caller、supervisor 和 responder 之间的调用链路可正常工作。",
    },
    {
      name: "新增自己的 Hotline",
      text: "使用 process 或 http 适配器创建你自己的 Hotline draft，并补全 summary、input_schema 和 output_schema。",
    },
    {
      name: "提交审核并检查状态",
      text: "将 Hotline 提交到 Platform 做 review，并通过 status 或 Console 检查在线状态。",
    },
  ],
};
